import { Component } from '@angular/core';
import { SideMenuComponent } from '../side-menu/side-menu.component';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-code-of-conduct',
  standalone: true,
  imports: [SideMenuComponent, TranslateModule],
  templateUrl: './code-of-conduct.component.html',
  styleUrl: './code-of-conduct.component.css'
})
export class CodeOfConductComponent {

  currentLanguage: string = '';

  baseApiUrl = environment.baseApiUrl;
  
  constructor(private translate: TranslateService) {}

   ngOnInit(): void {
    this.currentLanguage = this.translate.currentLang || this.translate.defaultLang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang;
    })
  }


}
